import React, { useState, useEffect } from 'react';
import { Home } from 'lucide-react';
import { Link } from 'react-router-dom'; // Import Link

const Logo = ({ isLoading = true }) => {
  return (
    <Link to="/" className="flex items-center gap-2"> {/* Wrap in Link */}
      <span className={`text-2xl font-bold text-white ml-3 ${isLoading ? 'logo-pulse' : ''}`}>VillaKosh</span>
    </Link>
  );
};

export default Logo;
